import { components } from "react-select";

const Menu = ({ children, ...props }) => (
	<components.Menu className="advanced-select-menu" {...props}>
		{children}
	</components.Menu>
);
export default Menu;
